import React, { useEffect } from "react";
import { ArrowLeftIcon, ArrowRightIcon, ChevronLeftIcon } from "lucide-react";
import { Button } from "../blog/BlogButton";
// import { Card, CardContent } from "./BlogCard";
import { Card, CardContent } from "../blog/BlogCard";
import "./CaseStudiesMain.css";
import NavComponent from "../../components/NavComponent";
import { useNavigate } from "react-router-dom";
import Pagenation from "../../components/Pagenation";
import { casestudiesPosts } from "../../Data/CaseStudiesData";
import SEOHelmet from "../../components/SEOHelmet";
// import BlogCardImage1 from "../../public/BlogCardImage1.jpg"

export const CaseStudiesMain = () => {
  const navigate = useNavigate();
  const categories = [
    "AI/ ML Solutions",
    "Application Engineering",
    "Cloud Solution",
    "Digital Transformation",
    "Enterprise Solutions",
    "IT Consulting",
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // const blogPosts = [
  //   {
  //     image: "/BlogCardImage1.jpg",
  //     title: "Health claims, reimagined! Canvendor's Agentic AI slashes delays",
  //     category: "Get to Know",
  //     date: "Aug 14,2025",
  //   },
  //   {
  //     image: "/BlogCardImage2.jpg",
  //     title: "Health claims, reimagined! Canvendor's Agentic AI slashes delays",
  //     category: "Get to Know",
  //     date: "Aug 14,2025",
  //   },
  //   {
  //     image: "/BlogCardImage3.jpg",
  //     title: "Health claims, reimagined! Canvendor's Agentic AI slashes delays",
  //     category: "Get to Know",
  //     date: "Aug 14,2025",
  //   },
  // ];

  const recentPosts = [
    {
      image: "https://c.animaapp.com/memovagbcMSRxN/img/rectangle-11.svg",
      title: "Assistant Manager – Finance",
    },
    {
      image: "https://c.animaapp.com/memovagbcMSRxN/img/rectangle-11-1.svg",
      title: "Assistant Manager – Finance",
    },
    {
      image: "https://c.animaapp.com/memovagbcMSRxN/img/rectangle-11-2.svg",
      title: "Assistant Manager – Finance",
    },
  ];

  const handleCardClick = (id) => {
    navigate("/casestudies2", { state: id });
  };

  return (
    <div className="blog-container">
      <SEOHelmet title="Casestudies" />

      {/* Hero Section */}
      <NavComponent />
      <section
        className="blog-hero"
        style={{
          backgroundImage: "url(/BlogBGImage.jpg)",
        }}
      >
        <div className="hero-overlay">
          <h1>Case Studies</h1>
          <p>Where Experience Meets Evidence</p>
        </div>
      </section>

      <div className="blog-layout">
        {/* Main Content */}
        <main className="blog-main">
          {/* Featured Post */}
          <Card className="featured-card">
            <CardContent className="featured-card-content">
              <div className="featured-text">
                <h2>
                  Get To Know: Pon Vijay,
                  <br /> UI/UX Designer at Canvendor
                </h2>
                <p>
                  Health claims, reimagined! Canvendor's Agentic AI slashes
                  delays, kills errors, and puts your claims on autopilot. Fast.
                  Smart. Hassle-free.
                </p>
                <div className="meta-info">
                  <span>Get to Know</span>
                  <span>Aug 14,2025</span>
                </div>
              </div>
              <div
                className="featured-image"
                style={{
                  backgroundImage: "url(/BlogBGImage2.jpg)",
                }}
              >
                <h3>
                  A Smarter Way to Handle
                  <br /> Health Claims
                </h3>
              </div>
            </CardContent>
          </Card>

          {/* Blog Posts Grid */}
          <div className="blog-grid">
            {casestudiesPosts.map((post, index) => (
              <Card
                // style={{height:'350px'}}
                key={index}
                className="blog-card"
                onClick={() => handleCardClick(post.id)}
              >
                <CardContent>
                  <img
                    src={post.image}
                    alt="casestud post"
                    className="blog-img"
                  />
                  <div className="blog-text">
                    <p>{post.title}</p>
                    <div className="meta-info">
                      <span>{post.category}</span>
                      <span className="card-date">{post.date}</span>
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>

          {/* Pagination */}
          <Pagenation />
        </main>

        {/* Sidebar */}
        <aside className="blog-sidebar">
          <div className="categories">
            <h3>Categories</h3>
            {categories.map((category, index) => (
              <div key={index} className="category-item">
                <ChevronLeftIcon />
                <span>{category}</span>
              </div>
            ))}
          </div>

          <div className="recent-posts">
            <h3>Recent Posts</h3>
            {recentPosts.map((post, index) => (
              <div key={index} className="recent-item">
                <img src={post.image} alt="Recent" />
                <span>{post.title}</span>
              </div>
            ))}
          </div>
        </aside>
      </div>
    </div>
  );
};
